import "bootstrap/js/src/modal";
import AOS from "aos";

import "./topbar";
import "./cookie-consent";
import "../styles/about.scss";

AOS.init();
